import React, { useState } from 'react';
import './Modal.css';

const AddHoursModal = ({ user, onConfirm, onClose }) => {
  const [hours, setHours] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    setError('');
    if (!hours || parseFloat(hours) <= 0) {
      setError('Введите положительное число часов');
      return;
    }
    onConfirm(hours, reason);
    setHours('');
    setReason('');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Добавить часы</h2>
          <button className="modal-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>Пользователь</label>
            <input type="text" disabled value={`${user.firstName} (@${user.username})`} />
          </div>
          <div className="form-group">
            <label>Часы</label>
            <input
              type="number"
              placeholder="Введите количество часов"
              min="0"
              step="0.5"
              value={hours}
              onChange={(e) => setHours(e.target.value)}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Причина (опционально)</label>
            <input
              type="text"
              placeholder="е.г., бонус за рефераль"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
          {error && <div className="form-error">{error}</div>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" onClick={handleSubmit}>Добавить</button>
        </div>
      </div>
    </div>
  );
};

export default AddHoursModal;
